import React from 'react'

import { COMMUNITY_SITE, MAIN_FAQ } from '@smarty-nx/code-utils'

export const content = {
  chatTitle:
    'Chat to our customer support team from 8am–8pm, or our SMARTY Bot 24/7',
  chatOpeningHours: (
    <span>
      Chat to our SMARTY bot 24/7, or our customer support team are available
      daily from 8am – 8pm to assist.
    </span>
  ),
  waitTimesAndOutsideOpeningTimes: (
    <>
      *Our wait times may vary depending on how busy we are. Our open days
      exclude Christmas Day and New Years Day. If you need help outside of these
      days or hours, check our out{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={MAIN_FAQ}
        data-testid="help-centre-link"
      >
        Help Centre
      </a>{' '}
      or{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={COMMUNITY_SITE}
        data-testid="community-link"
      >
        Community
      </a>
      .
    </>
  ),
  ctaText: 'Start a webchat',
  dataItemName: 'customer-dedicated-email',
  emailText:
    "To chat to us, click 'Start a webchat' below or select the web chat icon located at the bottom of your screen.",
}
